export default __webpack_public_path__ + "static/platform-tableau-de-bord-424382424e37c2acfcb6e7e76d694e73.png";